import omit from 'lodash/omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removePropertyType = (iri: string) => (model: Model) => {
  setDataProperty<ModelData>(model)(
    model.modelData,
    'propertyTypesByIri',
    omit(model.modelData.propertyTypesByIri, iri)
  );
};
